// FAQs js start
$('.faq-section-block-question').click(function(){
  if($(this).parent('.faq-section-main-block').hasClass('active')){
    $(this).parent('.faq-section-main-block').removeClass('active');
    $(this).parent('.faq-section-main-block').find('.faq-section-block-answer').slideUp();
  }else{
    $(this).parents('.media_faq_wrapper').find('.faq-section-main-block').removeClass('active');
    $(this).parents('.media_faq_wrapper').find('.faq-section-block-answer').slideUp();
    $(this).parent('.faq-section-main-block').addClass('active');
    $(this).parent('.faq-section-main-block').find('.faq-section-block-answer').slideDown();
  }
});
$('.product-acc-item:first-child').removeClass('active');
// $('.product-acc-item:first-child .product-acc-answer').slideDown();
$('.product-acc-question').click(function(){
  if($(this).parent('.product-acc-item').hasClass('active')){
    $(this).parent('.product-acc-item').removeClass('active');
    $(this).parent('.product-acc-item').find('.product-acc-answer').slideUp();
  }else{
    $(this).parent('.product-acc-item').addClass('active');
    $(this).parent('.product-acc-item').find('.product-acc-answer').slideDown();
  }
});



$(".green-helpers-button").on('click', function(e){
    e.preventDefault();
    $('.green-helpers-card').removeClass("active");
    $(this).parent('.green-helpers-card').toggleClass("active");
});